"use client";

import React, { ReactNode } from "react";

interface PageWrapperProps {
  children: ReactNode;
  maxWidth?: "4xl" | "6xl" | "7xl";
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  maxWidth = "7xl"
}) => {
  return (
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-8">
        {/* Main Content */}
        <div className={`max-w-${maxWidth} mx-auto`}>
          {children}
        </div>
    </div>
  );
};

export default PageWrapper;
